import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsScrollerOpenGameByUser = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/scrollers/open-game/by-user`, {params});
};